import React, { useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import { Button, Modal } from "react-bootstrap";
import Disposisi from "../../../utilities/Disposisi";
import UserService from "../../../services/user/UserService";
import { FaChevronCircleLeft } from "react-icons/fa";

const ModalViewSpp = ({ showViewPenugasan, handleCloseViewPenugasan, dataDisposisi, datappm }) => {

    const [listPenugasanDetil, setListPenugasanDetil] = useState([])

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])

    useEffect(() => {
        if (!dataDisposisi) return
        const fetchAllOptions = async () => {
            try {
                if (dataDisposisi.noTugas !== undefined) {
                    const resTugasDetil = await transaksiService.listPenugasanDetil(datappm.nomorAju, dataDisposisi.noTugas)
                    setListPenugasanDetil(resTugasDetil.data)
                }
            } catch (error) {
                console.log(error)
                // setListPenugasanDetil([])
            }
        }
        fetchAllOptions()
    }, [dataDisposisi, userService, datappm, transaksiService])


    return (
        <>
            <Modal show={showViewPenugasan}
                onHide={handleCloseViewPenugasan}
                backdrop='static'
                keyboard={false}
                size="lg"
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={dataDisposisi.nipPejabat + ' - ' + dataDisposisi.nmPejabat} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Petugas</label>
                        {
                            listPenugasanDetil !== undefined && listPenugasanDetil.map((detil, index) => {
                                return (
                                    <>
                                        <div className="col-sm-8">
                                            <input type="text" key={'detil' + index} className="col-sm-12 form-control-sm" name={'detil' + index} value={detil.nipPetugas + ' - ' + detil.namaPetugas} disabled />
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={handleCloseViewPenugasan}>
                        <FaChevronCircleLeft /> Kembali
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalViewSpp